import React, { useState, useCallback, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
  TabMenuContainer,
  LoaderContainer,
} from '../../containers/SidebarMenu/styles';
import FolderTabDetails from '../SidebarMenu/FolderTabDetails';
import Loader from '../../components/Loader';
import { DESIGN_AREA_FOLDERS_TAB } from '../SidebarMenu/translationValues';
import {
  useDocumentContext,
  COMPLEX_DOCUMENT_CONTEXT_KEYS,
} from '../../context/complexDocumentContext';
import { BusinessLogic } from '../../context/businessLogicContext';
import {
  addUuidToAllBlocksInDocument,
  removeCurrentBusinessLogics,
  getAllBlocksInDocument,
} from '../../utils/masterTemplateHelper';
import { updateBusinessLogic } from '../../utils/services/businessLogicApi';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { buildBusinessLogicMaps } from '../../utils/helper';

const NAMESPACES = ['DESIGN_AREA_FOLDERS_TAB'];

const ComplexFolderTab = props => {
  const { t, CurrentDesign } = props;
  const [isLoading, setIsLoading] = useState(false);

  const customSelector = useCallback(() => null, []);
  const [, methods] = useDocumentContext(customSelector, 'ComplexTemplateTab');
  const { businessLogics, setBusinessLogics } = useContext(BusinessLogic);

  const [, store] = useDocumentContext(customSelector, `ComplexTemplateTab`);

  const editableSelector = useCallback(store => store[CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN], []);
  const [editable] = useArtboardContext(editableSelector, 'ComplexArtboard');

  const handleBusinessLogic = async (blockIdsMap, selectedTemplate, flowIdsMap) => {
    const currentStore = store.get();
    const blBlocks = getAllBlocksInDocument(selectedTemplate.flows);
    const newlyAddedBusinessLogics = [];
    if (selectedTemplate?.businessLogics?.length) {
      for (let i = 0; i < selectedTemplate.businessLogics.length; i++) {
        const businessLogic = selectedTemplate.businessLogics[i];
        businessLogic.documentId = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID];
        businessLogic.id = null;
        businessLogic.rules = businessLogic.rules.map(rule => {
          rule.id = null;
          const origUuid = blBlocks.find(oBlock => oBlock.blockId?.includes(rule.blockId))?.uuid;
          if (origUuid) {
            rule.blockId =
              currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS][blockIdsMap.get(origUuid)];
          }
          if (rule.flowId && flowIdsMap) {
            const origFlowUuid = selectedTemplate.flows.find(oFlow =>
              oFlow.flowId?.includes(rule.flowId),
            )?.uuid;
            if (origFlowUuid) {
              rule.flowId =
                currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS][
                  flowIdsMap.get(origFlowUuid)
                ];
            }
          }
          return rule;
        });
        try {
          const response = await updateBusinessLogic(businessLogic);
          if (response?.data) {
            newlyAddedBusinessLogics.push(response.data);
          }
        } catch (e) {
          console.error(e);
        }
      }
      if (newlyAddedBusinessLogics.length) {
        setBusinessLogics(newlyAddedBusinessLogics);
        const {flowBusinessLogicMap, elementBusinessLogicMap} = buildBusinessLogicMaps(newlyAddedBusinessLogics, currentStore);
        methods.set({[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOW_BUSINESS_LOGIC]: flowBusinessLogicMap, [COMPLEX_DOCUMENT_CONTEXT_KEYS.ELEMENT_GROUPS]: elementBusinessLogicMap });
      }
    }
  };
  
  const handleApplyAllFlows = async selectedTemplate => {
    const flows = addUuidToAllBlocksInDocument(selectedTemplate.flows);
    const callback = ({ blockIdsMap, flowIdsMap }) => {
      const autosaveCallback = async () => {
        removeCurrentBusinessLogics(businessLogics, setBusinessLogics);
        handleBusinessLogic(blockIdsMap, selectedTemplate, flowIdsMap);
      };
      methods.set({
        [COMPLEX_DOCUMENT_CONTEXT_KEYS.AUTOSAVE_CALLBACK]: autosaveCallback,
        [COMPLEX_DOCUMENT_CONTEXT_KEYS.NEW_LANGUAGE_CODE]: selectedTemplate?.language,
        [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_DRAG_ACTION]: true,
      });
    };
    methods.replaceDocument(flows, selectedTemplate.style, callback);
  };

  return (
    <TabMenuContainer>
      {isLoading && (
        <LoaderContainer>
          <Loader />
          <div className="loading-txt">
            {t(
              DESIGN_AREA_FOLDERS_TAB.LOADING_FOLDERS.key,
              DESIGN_AREA_FOLDERS_TAB.LOADING_FOLDERS.value,
            )}
          </div>
        </LoaderContainer>
      )}
      <FolderTabDetails editable={editable} elementType={CurrentDesign} handleApplyAllFlows={handleApplyAllFlows}/>
    </TabMenuContainer>
  );
}

export default withTranslation(NAMESPACES)(withRouter(ComplexFolderTab));
